import { createStyles } from '@material-ui/core/styles';
import fonts from '../fonts';

export default createStyles({
  inputRoot: {
    fontSize: fonts.sizes.large,
    height: 40,
    '&.MuiAutocomplete-input': {
      paddingTop: '0!important',
    },
  },
  paper: {
    '& ul': {
      maxHeight: '300px',
    },
  },
});
